import { render, staticRenderFns } from "./DispatchRelated_List.vue?vue&type=template&id=2f40edc8&"
import script from "./DispatchRelated_List.vue?vue&type=script&lang=js&"
export * from "./DispatchRelated_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports